import type { AlterlyEffectInstance } from "../../core/effects/effectRegistry";
import { renderHalftone } from "./renderHalftone";
import { renderNoise } from "./renderNoise";

const sourceCanvas = document.createElement("canvas");
const effectCanvas = document.createElement("canvas");
const sourceContext = sourceCanvas.getContext("2d", { willReadFrequently: true });
const effectContext = effectCanvas.getContext("2d", { willReadFrequently: true });

function ensureSize(width: number, height: number) {
  if (sourceCanvas.width !== width || sourceCanvas.height !== height) {
    sourceCanvas.width = width;
    sourceCanvas.height = height;
  }
  if (effectCanvas.width !== width || effectCanvas.height !== height) {
    effectCanvas.width = width;
    effectCanvas.height = height;
  }
}

export function renderEffectStack(
  target: CanvasRenderingContext2D,
  source: CanvasImageSource,
  width: number,
  height: number,
  effects: readonly AlterlyEffectInstance[],
) {
  if (!sourceContext || !effectContext) return;
  ensureSize(width, height);

  sourceContext.clearRect(0, 0, width, height);
  sourceContext.drawImage(source, 0, 0, width, height);

  for (const effect of effects) {
    if (!effect.enabled || effect.opacity <= 0) continue;

    effectContext.clearRect(0, 0, width, height);
    if (effect.definitionId === "halftone") {
      renderHalftone(effectContext, sourceCanvas, width, height, effect.parameters);
    } else {
      renderNoise(effectContext, sourceCanvas, width, height, effect.parameters);
    }

    sourceContext.save();
    sourceContext.globalAlpha = Math.max(0, Math.min(1, effect.opacity));
    sourceContext.drawImage(effectCanvas, 0, 0);
    sourceContext.restore();
  }

  target.clearRect(0, 0, width, height);
  target.drawImage(sourceCanvas, 0, 0);
}
